/**
 * Small helpers the catalog surfaces share (BLU-1268). Pure.
 */
import { catalogImage, type CatalogSupplier } from './catalog-picker';

/** A file we ship ourselves: `/brand/...`, with no way back out of that folder. */
const BRAND_PATH = /^\/brand\/(?!.*\.\.)[\w./-]+$/;

/**
 * A catalog supplier's logo the browser may load, or null: an https address (the
 * catalog photo rule) or a file under `/brand/`. Anything else is treated as no
 * logo, so `//host`, `http:`, `data:` and `javascript:` never reach an `<img>`.
 */
export function supplierLogoSrc(url: string | null | undefined): string | null {
  const value = url?.trim();
  if (!value) return null;
  return BRAND_PATH.test(value) ? value : catalogImage(value);
}

/** Where a catalog supplier opens: the linked supplier's Catalog tab, or the catalog supplier's own page. */
export function catalogHref(row: Pick<CatalogSupplier, 'id' | 'linkedSupplier'>): string {
  return row.linkedSupplier ? `/suppliers/${row.linkedSupplier.id}?tab=catalog` : `/suppliers/catalog/${row.id}`;
}

/** A 2-letter region code in the reader's language; anything else as written; null when empty. */
export function countryName(country: string | null, language: string): string | null {
  const value = country?.trim();
  if (!value) return null;
  if (!/^[A-Za-z]{2}$/.test(value)) return value;
  try {
    return new Intl.DisplayNames([language], { type: 'region' }).of(value.toUpperCase()) ?? value;
  } catch {
    return value;
  }
}
